var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0V8h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M10.905 6.365l.675.487-.255.803L12 7.16l.675.495-.255-.803.675-.495-.84.008L12 5.562l-.262.803h-.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M14.003 4.535c-.61-.349-1.3-.533-2.003-.532v1.042a2.956 2.956 0 11-.218 5.903 2.957 2.957 0 01-1.282-.39 2.88 2.88 0 01-.99-.93l-.87.577a3.997 3.997 0 105.34-5.67h.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9.69 7.302a1.043 1.043 0 00.42 1.448l3.39 1.822a.847.847 0 00.308 1.178l.915.502a.877.877 0 001.185-.345l.495-.907L9.69 7.302z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngola);
export default __webpack_public_path__ + "static/media/Angola.9b39495523434c29e4a6c85ad496e1f4.svg";
export { ForwardRef as ReactComponent };